import { midiTickToSeconds } from "./vstMidiFile";

// Keep several sixteenth notes queued in the Web Audio clock even at high BPM.
// The UI timer only feeds this queue; it must never be the actual audio clock.
export const MIDI_LOOKAHEAD_MS = 250;
export const MIDI_SCHEDULER_INTERVAL_MS = 20;
export const MIDI_START_DELAY_MS = 100;

export const buildMidiPlaybackTimeline = (sequence) => {
  const groups = [];
  (sequence?.events || []).forEach((event, index) => {
    const due = midiTickToSeconds(sequence, event.tick) * 1000;
    const previous = groups[groups.length - 1];
    if (previous && previous.due === due) previous.events.push({ event, index });
    else groups.push({ due, events: [{ event, index }] });
  });
  const duration = Math.max(
    1,
    midiTickToSeconds(sequence, Number(sequence?.durationTicks) || 0) * 1000,
    groups[groups.length - 1]?.due || 0,
  );
  return { groups, duration };
};
